import { Route, Routes } from 'react-router-dom'
import MainPage from '../pages/MainPage';
import SecondPage from '../pages/SecondPage';
import ErrorPage from '../pages/ErrorPage';
import RulesPage from "../pages/RulesPage";
import ConfidentialPage from "../pages/ConfidentialPage";
import BlackListDomainPage from "../pages/BlackListDomainPage";

const Router = () => {
  return (
    <Routes>
        <Route path="/" index element={<MainPage />} />
        <Route path="/rules" index element={<RulesPage/>} />
        <Route path="/confidential" index element={<ConfidentialPage/>} />
        <Route path="/blacklist" index element={<BlackListDomainPage />} />
        <Route path="/second" index element={<SecondPage />} />
        <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default Router;
